import { Observable, from as from$1, fromEvent as fromEvent$1 } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { isRef, watch, ref } from 'vue-demi';
import { tryOnUnmounted } from '@vueuse/shared';

function from(value) {
    if (isRef(value)) {
        return new Observable((subscriber) => {
            watch(value, val => subscriber.next(val));
        });
    }
    else {
        return from$1(value);
    }
}
function fromEvent(value, event) {
    return from(value).pipe(filter(value => value instanceof HTMLElement), mergeMap(value => fromEvent$1(value, event)));
}

function toObserver(value) {
    return {
        next: (val) => {
            value.value = val;
        },
    };
}

function useObservable(observable) {
    const value = ref();
    const subscription = observable.subscribe(val => (value.value = val));
    tryOnUnmounted(() => {
        subscription.unsubscribe();
    });
    return value;
}

function useSubscription(subscription) {
    tryOnUnmounted(() => {
        subscription.unsubscribe();
    });
}

export { from, fromEvent, toObserver, useObservable, useSubscription };
